import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436875ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exchange-coupon-finished" }
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-18 text-weight-500 mt-3" }, [
  /*#__PURE__*/_createTextVNode("\n            交換申請が"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("完了しました\n          ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n            申請から3営業日以内に、登録メールアドレス宛にギフト券コードをお送りします\n          ")
], -1))

import { onMounted } from "vue";
import Header from "@/components/organisms/common/Header.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { inAppReviewService } from "@/app/services/InAppReviewService";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeCouponFinished',
  setup(__props) {

const customRouter = useCustomRouter();

onMounted(async () => {
  await inAppReviewService.launchInAppReview("EXCHANGE_POINT");
});

const myPointRoute = { name: "MyPoint" };

async function onClickClose() {
  await customRouter.pushIgnoreError(myPointRoute);
}

return (_ctx: any,_cache: any) => {
  const _component_ExchangeCompletion = _resolveComponent("ExchangeCompletion")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      right: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "x",
          onClick: onClickClose
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      交換申請完了\n      ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ExchangeCompletion),
          _createTextVNode(),
          _hoisted_4
        ]),
        _createTextVNode(),
        _hoisted_5,
        _createTextVNode(),
        _createVNode(_component_RouterLink, { to: myPointRoute }, {
          default: _withCtx(() => [
            _createVNode(AppButtonOutline, {
              block: true,
              class: "text-primary-dark text-weight-500"
            }, {
              default: _withCtx(() => [
                _createTextVNode("閉じる")
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})